import React, { Component } from "react"
import infoChart from '../../codeinfo.json'

export default class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      hasResult: false,
      message: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    this.setState({value: e.target.value});
  }

  handleSubmit(e) {
    e.preventDefault();
    this.calculateDatecode(this.state.value)
  }

  calculateDatecode(value) {

    // render result based on parsed values and show message
    const renderResult = (codeKey) => {
      console.log(codeKey)

      if (codeKey <= 30) {
        const key = parseInt(codeKey)
        let created = infoChart[key].created
        let characteristics = infoChart[key].characteristics

        this.state.message = `The serial code indicates a production date of: <strong>${created}</strong>.
        <br/><br/>
        <em>Additional serial sticker authentication criteria:</em>
        <br/><br/>
        ${characteristics}

        <br/><br/>
        <small>Characteristic research from <a href="https://www.yoogiscloset.com/authenticate/chanel">Yoogi's Closet</a>.</small>`
        
      } else {
        this.state.message = "This indicates an invalid serial code. Double check to make sure you haven't entered any additional characters (like spaces)."
      }

      this.setState({ hasResult: true });
    }

    const handleValue = (value) => {
      // Check for number of digits (if 7 digits, look for just first number)
      if (value.length === 7) {
        const codeKey = value.substring(0,1)
        renderResult(codeKey)
      }

      // Check for number of digits (if 8, look for first 2 numbers)
      else if (value.length === 8 && value.substring(0,1) != '0') {
        const codeKey = value.substring(0,2)
        renderResult(codeKey)
      }

      // if its not one of the above it's not a valid date code
      else {
        renderResult()
      }
    }

    handleValue(value)
  }

  render() {
    const result = this.state.hasResult ? (
      <div>
        <h3>{this.state.value}:</h3>
        <p dangerouslySetInnerHTML={{__html: this.state.message}}></p>
      </div>
    ) : (
      ''
    )

    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <label>
            Product Code: 
            <input placeholder="Enter code here" type="text" value={this.state.value} onChange={this.handleChange} />
          </label>
          <input type="submit" value="Submit" />
        </form>
        <div className="result">
          {result}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/form.js